<template>
  <md-card>
    <md-card-content>
      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <h4 class="card-title">Datos del cliente</h4>
        </div>
        <form class="md-layout-item" id="customer_form" @submit.prevent="saveCustomer()">
          <div class="md-layout">
            <div class="md-layout-item md-medium-size-50">
              <md-field :class="validationClass('name')">
                <label for="name">Nombre</label>
                <md-input
                  data-vv-name="name"
                  v-validate="modelValidations.name"
                  v-model="updatedCustomer.name"
                ></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-medium-size-50">
              <md-field :class="validationClass('customerType')">
                <label for="customer_type">Tipo de Cliente</label>
                <md-select
                  data-vv-name="customerType"
                  v-validate="modelValidations.customerType"
                  v-model="updatedCustomer.customerTypeId"
                  name="customer_type"
                >
                  <md-option
                    v-for="customerType in customerTypes"
                    :value="customerType.id"
                    :key="customerType.id"
                  >{{ customerType.name }}</md-option>
                </md-select>
              </md-field>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-medium-size-50">
              <md-field :class="validationClass('codename')">
                <label for="codename">Nombre corto</label>
                <md-input
                  v-model="updatedCustomer.codename"
                  data-vv-name="codename"
                  v-validate="modelValidations.codename"
                ></md-input>
              </md-field>
            </div>
          </div>

          <div class="md-layout">
            <fiscal-data
              @setAsentamiento="(v) => (updatedCustomer.asentamiento = v)"
              :fiscalData="fiscalData"
              :banks="banks"
            ></fiscal-data>
          </div>

          <div class="md-layout">
            <contact-data
              showCopyAddress
              :copiableAddress="fiscalData"
              :contactData="updatedCustomer.contactData"
            ></contact-data>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <staff :customerId="customer.id" v-if="customer.id"></staff>
            </div>
          </div>

          <div class="md-layout">
            <image-field :editedObject="updatedCustomer" :useBase64="true"></image-field>
          </div>
        </form>
      </div>
    </md-card-content>
    <md-card-actions>
      <md-button type="submit" form="customer_form" class="md-success">Aceptar</md-button>
    </md-card-actions>
  </md-card>
</template>

<script>
import { ImageField } from "@/components";
import catalogService from "@/services/catalog";
import { ContactData, FiscalData } from "@/components";
import providesValidatorMixin from "@/mixins/providesValidator";
import Staff from "./Staff";

const modelValidations = {
  name: {
    required: true,
  },
  customerType: {
    required: true,
  },
  codename: {
    required: true,
    min: 3,
  },
};

export default {
  name: "EditCustomer",

  mixins: [providesValidatorMixin],

  components: {
    ImageField,
    ContactData,
    FiscalData,
    Staff,
  },

  props: {
    customer: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      customerTypes: [],
      banks: [],
      updatedCustomer: {},
      modelValidations,
      defaultCustomer: {
        contactData: {
          address: {},
        },
        fiscalData: {
          fiscalAddress: {},
        },
      },
    };
  },
  methods: {
    saveCustomer() {
      const uCustomer = {
        ...this.updatedCustomer,
        fiscalData: this.fiscalData,
      };
      const payload = { original: this.customer, updated: uCustomer };
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.$emit("saved", payload);
        }
      });
    },
  },
  created() {
    this.updatedCustomer = { ...this.defaultCustomer, ...this.customer };
    catalogService
      .fetch("customer/customertype")
      .then((customerTypes) => (this.customerTypes = customerTypes));
    catalogService.fetch("common/states", { useStore: true });
    catalogService.fetch("banks").then((res) => (this.banks = res));
  },
  mounted() {
    this.watchTouched({ updatedCustomer: Object.keys(modelValidations) });
  },
  watch: {
    customer() {
      this.unwatchTouched();
      this.updatedCustomer = { ...this.defaultCustomer, ...this.customer };
      this.watchTouched({ updatedCustomer: Object.keys(modelValidations) });
    },
  },
  computed: {
    fiscalData: {
      set: function (fiscalData) {
        this.updatedCustomer.fiscalData = fiscalData;
      },
      get: function () {
        const fiscalData = this.updatedCustomer.fiscalData;
        // if (this.copyCustomerAddress) {
        //   const address = this.updatedCustomer.contactData.address
        //   const fiscalAddress = fiscalData.fiscalAddress

        //   for (const prop in address) {
        //     if (!address.hasOwnProperty(prop)) {
        //       continue
        //     }

        //     if (fiscalAddress[prop] != address[prop]) {
        //       fiscalAddress[prop] = address[prop]
        //       // fiscalData.fiscalAddress = {...address}
        //       // return
        //     }
        //   }
        //   return fiscalData
        // } else {
        //   return fiscalData
        // }
        return fiscalData;
      },
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/pages/Customers/Edit.vue